import React from 'react';
import PropTypes from 'prop-types';
import {Button} from 'Common/Structure';

import './fileUploader.scss';

const FileUploader = React.forwardRef((props, ref) => (
  <span className="upload-btn-wrapper">
    <input
      ref={ref}
      accept={props.fileTypes}
      id="file"
      multiple={props.multiple}
      onChange={props.onChange}
      type="file"
    />
    <Button secondary>Select Files</Button>
  </span>
));

FileUploader.defaultProps = {
  fileTypes:
    'image/*,.jpg,.jpeg,.png,.gif,.tiff,.zip,.7z,.rar,.xls,.xlsx,.doc,.docx,.txt,.csv,.pdf,.msr',
};

FileUploader.propTypes = {
  fileTypes: PropTypes.string,
  ref: PropTypes.instanceOf(Element),
  multiple: PropTypes.bool,

  // functions
  onChange: PropTypes.func.isRequired,
};

export default FileUploader;



// WEBPACK FOOTER //
// ./src/components/Common/Form/FileUploader.js